/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Ai_Tools_How_TitleInputs */

const en_directory_ai_tools_how_title = /** @type {(inputs: Directory_Ai_Tools_How_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How it works`)
};

const zh_directory_ai_tools_how_title = /** @type {(inputs: Directory_Ai_Tools_How_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使用步骤`)
};

/**
* | output |
* | --- |
* | "How it works" |
*
* @param {Directory_Ai_Tools_How_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_ai_tools_how_title = /** @type {((inputs?: Directory_Ai_Tools_How_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Ai_Tools_How_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_ai_tools_how_title(inputs)
	return zh_directory_ai_tools_how_title(inputs)
});
export { directory_ai_tools_how_title as "directory.ai_tools.how_title" }